"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var loginUserRole = localStorage.getItem("rolename");
loginUserRole = loginUserRole && loginUserRole.toUpperCase();
var rolecode = loginUserRole === "D.G" || loginUserRole === "PGR_LME" ? "PGR_LME" : loginUserRole === "GRO" ? "GRO" : loginUserRole === "ESCALATION_OFFICER1" ? "ESCALATION_OFFICER1" : loginUserRole === "ESCALATION_OFFICER2" ? "ESCALATION_OFFICER2" : "";

var formConfig = {
  name: "comment",
  fields: {
    comment: {
      id: "citizen-comment",
      jsonPath: "actionInfo[0].comments",
      hintText: "Write your comments...",
      value: "",
      required: true
    },
    rolecode: {
      id: "rolecode",
      jsonPath: "actionInfo[0].rolecode"
      //  value: rolecode,
    }
    // assigne: {
    //   id: "assigne",
    //   jsonPath: "actionInfo[0].assigne",
    //   //  value: rolecode,
    // },
    // status: {
    //   id: "status",
    //   jsonPath: "actionInfo[0].status",
    //   //  value: rolecode,
    // },
  },
  action: "_update",
  saveUrl: "/rainmaker-pgr/v1/requests/_update",
  //   saveUrl: `/rainmaker-pgr/v1/requests/_update?rolecode=${rolecode}`,
  redirectionRoute: ""
};

exports.default = formConfig;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/config/forms/specs/pgr/comment.js
// module id = 2088
// module chunks = 1137